import { useNavigate } from "react-router-dom";
import { BoxFiltros, ItensContainer } from "./style";
import Table from "./Table";
import Substrato from "../../assets/substrato.svg";
import { useState } from "react";
import { ReactSVG } from "react-svg";

const Substratos = () => {
  const navigate = useNavigate();
  const [statusSelecionado, setStatusSelecionado] = useState("");
  const [textoPesquisa, setTextoPesquisa] = useState("");

  function NovaSubstrato() {
    navigate("/substrato/novo");
  }

  return (
    <ItensContainer>
      <div className="box">
        <div className="flex">
          <ReactSVG src={Substrato} className="icone" />
          <h1>Substrato</h1>
        </div>
        <BoxFiltros>
          <div className="filtro">
            <input
              placeholder="Pesquisar por ID ou nome do substrato"
              value={textoPesquisa}
              onChange={(e) => setTextoPesquisa(e.target.value)}
            />
            <div>
              <p>Filtrar por status</p>
              <select
                value={statusSelecionado}
                onChange={(e) => setStatusSelecionado(e.target.value)}
              >
                <option value="">Ver todos</option>
                <option value={1}>ativo</option>
                <option value={0}>inativo</option>
              </select>
            </div>
          </div>
          <button onClick={NovaSubstrato}>Novo Substrato</button>
        </BoxFiltros>
        <Table
          statusSelecionado={statusSelecionado}
          textoPesquisa={textoPesquisa}
        />
      </div>
    </ItensContainer>
  );
};

export default Substratos;
